<template>
  <v-container fluid class="pa-0 ma-0">

    <!--<div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>-->
    <m2h-unbox-challenge-widget-one v-if="challenge && challenge.properties && challenge.properties.customWidgetIdentifier && challenge.properties.customWidgetIdentifier === 'UNBOX_CHALLENGE_1' && challenge.registrationModule"></m2h-unbox-challenge-widget-one>

    <m2h-wefitter-challenge-widget v-if="challenge && challenge.properties && challenge.properties.weFitterType && challenge.registrationModule" :challenge-id="challengeId" :challenge="translatedChallenge"></m2h-wefitter-challenge-widget>
    
  </v-container>
</template>

<script>

import api from "@/api/api";

export default {
  name: "m2h-challenges-detail",
  props: ['challengeId'],
  data() {
    return {
      isLoading: true,
      challenge: {}
    }
  },
  
  computed: {
    translatedChallenge() {
      let challenge = {...this.challenge}
      
      challenge.translation = null
      if (challenge.contentStructure && challenge.contentStructure.asset && challenge.contentStructure.asset.assetTranslations.length){
        if (challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)){
          challenge.translation = challenge.contentStructure.asset.assetTranslations.find((t) => t.language === this.$i18n.locale)
        }
      }
      return challenge
    }
  },

  mounted(){
    this.fetchChallenge()
  },

  methods: {
    async fetchChallenge(){
      this.isLoading = true
      this.challenge = await api.challenges.getChallenge(this.challengeId).then((res) => { return res.data })
      this.isLoading = false
    },
  }
}
</script>

<style scoped>

</style>
